// extracted by mini-css-extract-plugin
export default {"afterpayBtnWrapper":"g7-z","button":"h7-z","disabled":"i7-z","creditCard":"j7-z","wrapper":"k7-z"};